module.exports = __webpack_public_path__ + "53729bc5c67173b93cd653ace7916d4f.png";